import { useOfflineSync } from "@/lib/offlineQueue";
import { CloudOff, CloudUpload } from "lucide-react";

/** Small floating status pill (top-right of the page) that surfaces offline / pending-sync state. */
const OfflineIndicator = () => {
  const { online, pending } = useOfflineSync();
  if (online && pending === 0) return null;

  if (!online) {
    return (
      <div data-testid="offline-indicator-offline"
        className="fixed top-20 right-4 z-30 inline-flex items-center gap-2 px-3 py-2 bg-amber-100 text-amber-900 border-2 border-amber-300 text-xs font-bold shadow-md">
        <CloudOff size={14} strokeWidth={2.5}/> Offline — changes will sync when you&apos;re back online
        {pending > 0 && <span className="ml-1 px-1.5 py-0.5 bg-amber-900 text-white rounded-full">{pending}</span>}
      </div>
    );
  }
  return (
    <div data-testid="offline-indicator-syncing"
      className="fixed top-20 right-4 z-30 inline-flex items-center gap-2 px-3 py-2 bg-teal-50 text-teal-900 border-2 border-teal-300 text-xs font-bold shadow-md animate-pulse">
      <CloudUpload size={14} strokeWidth={2.5}/> Syncing {pending} pending update{pending>1?"s":""}…
    </div>
  );
};

export default OfflineIndicator;
